import { QueryClient } from '@tanstack/react-query';

export const invalidateSlideVisibility = (queryClient: QueryClient, studyId: string) =>
  Promise.all(
    [
      ['procedures'],
      ['study', studyId],
      ['studies'],
      ['studyUploads', studyId],
      ['pendingSlides'],
      ['pendingSlidesCount'],
      ['slideCaseAssignmentOptions'],
      ['labUploadSummary'],
      ['labLostAndFound'],
    ].map((queryKey) => queryClient.invalidateQueries({ queryKey, exact: false }))
  );
